import { Dispatch } from 'redux';
import { lang } from '../config/app.config';
import  {
  searchFail,
  searchRequest,
  searchSuccess
} from '../store/ActionReducers/search.actionreducer';
import { httpbase } from '../utils/axios.utils';

export const ecnSearch = (keyword:string) =>{
  return async(dispatch:Dispatch) =>{
    dispatch(searchRequest());
    try{
      const response = await httpbase().get('/search?keyword='+keyword+'&&lang='+lang)
      const data = {
        searches:response.data.data,
        keyword:keyword
      }
      dispatch(searchSuccess(data));
    }catch(e:any){
      if(e && e.response && e.response.data){
        dispatch(searchFail(e.response.data));
      }
      dispatch(searchFail("Something went wrong!"));
    }
  }
}


